import { ColumnsType } from 'antd/es/table';
import * as React from 'react';
import {ReactComponent as EditIcon} from '@iba-team/portal-react-components/dist/svg/outline/edit.svg';
import {ReactComponent as DeleteIcon} from '@iba-team/portal-react-components/dist/svg/outline/trash.svg';
import LeaveTypes from '../LeaveTypes';
import { LeaveTypesI, UnionLocations } from '../../types';
import {ReactComponent as DoneIcon} from '@iba-team/portal-react-components/dist/svg/solid/check-circle.svg';
import { ReactComponent as RejectIcon } from '@iba-team/portal-react-components/dist/svg/solid/clear-circle.svg';
import { ReactComponent as AutoIcon } from '@iba-team/portal-react-components/dist/svg/solid/refresh.svg';
import { applicationTemplateModalCall, deleteApplicationTemplateModalCall } from './ApplicationTemplatesPage';
import { ApplicationTemplatesGrid } from '../../store/ApplicationTemplates';
import { buildDownloadFile } from '../../utils/functions';
import {format} from 'date-fns';
import { Tooltip } from '@iba-team/portal-react-components/dist';
import { useTranslation } from 'react-i18next';
export const APPLICATION_TEMPLATE_COLUMNS = (
  leaveTypes: LeaveTypesI[],
  dataSource: ApplicationTemplatesGrid[],
  currentLocation: UnionLocations,
  downloadTemplateFile: (ref: string) => Promise<Response>
):  ColumnsType<ApplicationTemplatesGrid> | undefined => {
  const {t} = useTranslation();
  return ([
    {
      title: 'Leave Type',
      dataIndex: 'requestTypeForCountryName',
      key: 'requestTypeForCountryName',
      render: (requestTypeForCountryName) => <div>
        <LeaveTypes type={requestTypeForCountryName} infoMessageVisible={false} leaveTypes={leaveTypes}/>
      </div>
    },
    {
      title: 'Label',
      dataIndex: 'label',
      key: 'label',
      render: (label) => <div>{label ? <div>{label}</div> : <div className={'no-content-string'}>-</div>}</div>
    },
    {
      title: 'Template',
      dataIndex: 'templateName',
      className: 'template_column',
      key: 'templateName',
      render: (templateName, data) => <>{templateName ? <div className='template-element' onClick={()=> {
        if(data.ref){
          downloadTemplateFile(data.ref).then((response) => {
            return response.blob();
          }).then((blob) => buildDownloadFile(blob, data?.fileName || 'template'));
        }
      }
      }>{templateName}</div> : <div className={'no-content-string'}>no template</div>}</>
    },
    {
      title: 'Obligatory for leave request creation',
      className: 'obligatory_column',
      dataIndex: 'obligatoryType',
      key: 'obligatoryType',
      render: (obligatoryType) => { 
        if (obligatoryType) { 
          if (obligatoryType === 'OBLIGATORY') {
            return <div className={'obligatory_column_done'}><DoneIcon /></div>;
          } else if (obligatoryType === 'NON_OBLIGATORY') {
            return <div className={'obligatory_column_reject'}>
              <RejectIcon />
              <div>available only on the help page</div>
            </div>;
          } else if (obligatoryType === 'AUTOMATICALLY') {
            return <div className={'obligatory_column_auto'}>
              <AutoIcon />
              <div>automatically generate and attach to a leave request</div>
            </div>;
          }               
        }
        return <div className={'no-content-string'} style={{ textAlign: 'center' }}>-</div>;
      }
    },
    {
      title: 'Last updates',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (updatedAt, element) => <div className={'updated_column'}>
        {updatedAt ?
          <div>
            <div className={'update_date'}>
              {format(new Date(updatedAt), 'dd.MM.yyyy hh:mm:ss')}
            </div>
            <div className={'updator_name'}>by {element.updatedBy}</div>
          </div>
          :
          <div className={'no-content-string'}> - </div>
        }
      </div>
    },
    {
      title: 'Actions',
      className: 'actions_column',
      dataIndex: 'actions',
      key: 'actions',
      render: (_,item) => <div className={'actions_column__actions'}>{item.templateName ? <div>
        <Tooltip title={t('edit')}>
          <EditIcon className={'editIcon'}
            onClick={()=> applicationTemplateModalCall.showImmediately({tableData: dataSource, currentTemplate: item})}/>
        </Tooltip>
        <Tooltip title={t('delete')}>
          <DeleteIcon className={'deleteIcon'}
            onClick={()=> deleteApplicationTemplateModalCall.showImmediately({templateData: {id: item.id, templateName: item.templateName}, currentLocation: currentLocation })}/>
        </Tooltip>
      </div>
        :
        <div className={'add_template_btn'} onClick={()=> applicationTemplateModalCall.showImmediately({tableData: dataSource, currentTemplate: item})}>+ Add</div>}</div>
    },
  ]);
};
